import FounderContainer from './founder_container';

const Founder = FounderContainer;
export default Founder;
